<template>
  <div
    layout="row"
    flex
  >
    <div
      layout="column"
      class="messages-col"
      layout-align="start start"
      flex
    >
      <div
        layout="column"
        layout-align="start start"
        class="bg-white full-width pa-2"
      >
        <div
          layout="row"
          layout-align="start start"
          class="full-width"
        >
          <div
            v-if="!isCurrent"
            class="backlink"
            :class="[isMinistry ? '': 'mb1-mobile']"
          >
            <a
              layout="row"
              layout-align="start center"
              @click="$router.push({name: 'representatives-index'})"
            >
              <v-icon
                class="mr-1"
                color="grey"
              >mdi-chevron-left</v-icon>
              {{$t('representatives.back')}}
            </a>
          </div>
          <span flex></span>

          <v-btn
            depressed
            class="my-0 ml-0 mr-1"
            color="transparent"
            :title="$t('representatives.private_title')"
            icon
            @click="sendPrivate(user)"
            small
            flat
          >
            <v-icon color="secondary">mdi-email</v-icon>
          </v-btn>

          <v-btn
            v-if="isMinistry && !user.is_enabled && !user.is_deleted"
            depressed
            class="my-0 ml-0 mr-1"
            color="transparent"
            :title="$t('representatives.mail_title')"
            icon
            @click="sendMail"
            small
            flat
          >
            <v-icon color="secondary">mdi-send</v-icon>
          </v-btn>

          <v-btn
            v-if="isMinistry && !user.is_deleted"
            depressed
            class="my-0 ml-0 mr-1"
            color="transparent"
            :title="$t('_.delete')"
            icon
            @click="deleteDialog = true"
            small
            flat
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>

          <v-btn
            v-if="isMinistry || isCurrent"
            depressed
            class="ma-0 hidden-sm-and-down"
            color="secondary"
            small
            @click="editProfile"
            style="text-transform: none"
          >{{ isCurrent ? $t('representatives.edit_profile') : $t('representatives.edit')}}</v-btn>

          <v-btn
            v-if="isMinistry || isCurrent"
            depressed
            class="ma-0 hidden-md-and-up"
            color="transparent"
            icon
            @click="editProfile"
            flat
          >
            <v-icon color="secondary">mdi-pencil</v-icon>
          </v-btn>
        </div>
        <div
          layout="row"
          layout-align="start center"
          class="full-width mb-4 ml-1"
        >
          <avatar
            :size="$vuetify.breakpoint. smAndDown ? 40 : 70"
            :image="getImageData(user.id)"
            :fullname="user.firstname + ' ' + user.lastname"
          ></avatar>
          <div
            layout="column"
            layout-align="center start"
            class="ml-3 ml1-mobile"
            flex
          >
            <div
              layout="row"
              class="pl-1 mb-2 mb1-mobile font-weight-light"
              :class="[$vuetify.breakpoint. smAndDown ? 'headline': 'display-1']"
            >{{user.firstname}} {{user.lastname}}</div>
            <div
              layout="row"
              class="pl-1 font-weight-regular mb-2 mb1-mobile"
              :class="[$vuetify.breakpoint. smAndDown ? 'subheading': 'title']"
            >{{user.school.name}}</div>
            <div
              layout="row"
              layout-align="start center"
              layout-wrap
              class="title"
            >
              <v-chip
                label
                :color="levelColor(user.level)"
                class="text-lowercase mr-3"
                text-color="white"
                style="width: fit-content"
              >{{levelLabel(user.level)}}</v-chip>
              <span
                v-if="isMinistry && user.cycle_id && user.cycle"
                class="mr-3"
              >/ {{user.cycle.label}}</span>
              <span
                v-if="isMinistry && user.regime_id && user.regime"
                class="mr-3"
              >/ {{user.regime.label}}</span>
              <span
                v-if="isMinistry && (user.sector == primary) && !user.cycle_id"
                class="mr-3 font-weight-regular subheading"
                layout="row"
                layout-align="start center"
              >
                /
                <v-icon
                  color="warning"
                  :title="$t('representatives.cycle_miss')"
                  class="mx-1"
                >mdi-alert</v-icon>
                <span class="hidden-sm-and-down">{{$t('representatives.cycle_miss')}}</span>
              </span>
              <span
                v-if="isMinistry && (user.sector == secondary) && !user.regime_id"
                class="mr-3 font-weight-regular subheading"
                layout="row"
                layout-align="start center"
              >
                /
                <v-icon
                  color="warning"
                  :title="$t('representatives.regime_miss')"
                  class="mx-1"
                >mdi-alert</v-icon>
                <span class="hidden-sm-and-down">{{$t('representatives.regime_miss')}}</span>
              </span>
              <span
                v-if="(isMinistry || isCurrent || user.phone_displayed) && user.phone && user.phone != undefined"
                class="font-weight-regular subheading mr-3"
                layout="row"
                layout-align="start center"
              >
                <v-icon
                  size="18"
                  class="mr-1"
                >mdi-phone</v-icon>
                {{user.phone}}
              </span>
              <span
                v-if="(isMinistry || isCurrent || user.email_displayed) && user.email && user.email != undefined"
                class="font-weight-regular subheading mr-3"
                layout="row"
                layout-align="start center"
              >
                <v-icon
                  size="18"
                  class="mr-1"
                >mdi-email</v-icon>
                <a
                  :href="'mailto:' + user.email"
                  class="break-word"
                >{{user.email}}</a>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        id="message-form"
        v-show="isEditingMessage || isEditingEvent"
        layout="column"
        layout-align="start start"
        class="full-width px2-pc py3-pc pa1-mobile mt10-pc mt2-mobile bg-white"
      >
        <message-form
          v-if="isEditingMessage"
          @cancel="onMessageCancel"
          @save="save"
          ref="messageForm"
          v-model="editingMessage"
          :loading="loading"
        ></message-form>
        <message-form
          v-if="isEditingEvent"
          is-event
          @cancel="onEventCancel"
          @save="save"
          ref="messageForm"
          v-model="editingMessage"
          :loading="loading"
        ></message-form>
      </div>
      <message
        v-for="(m,i) in messages"
        :key="m.id"
        :message="m"
        class="bg-white full-width"
        style="margin-top: 10px"
        @edit="editMessage(m)"
        @removed="onDelete(i)"
        @deleted="onDelete(i)"
      ></message>
      <div
        v-if="loading && !noMoreData"
        layout="row"
        layout-align="center center"
        class="mt-3 full-width font-weight-black"
        style="color: #616161"
      >{{$t('messages.loading')}}</div>
      <div
        v-if="loading && !noMoreData"
        layout="row"
        layout-align="center center"
        class="mt-2 full-width"
      >
        <beat-loader
          :loading="loading && !noMoreData"
          color="grey"
        ></beat-loader>
      </div>
      <div
        v-if="!loading && noMoreData && !messages.length && !isCurrent"
        layout="row"
        layout-align="center center"
        class="mt-3 full-width font-weight-black text-xs-center"
        style="color: #616161"
      >{{user.firstname}} {{user.lastname}} {{$t('representatives.no_message')}}</div>
      <div
        v-else-if="!loading && noMoreData && !messages.length && isCurrent"
        layout="row"
        layout-align="center center"
        class="mt-3 full-width font-weight-black text-xs-center"
        style="color: #616161"
      >{{$t('representatives.no_mess_you')}}</div>
    </div>

    <div
      layout="column"
      layout-align="start start"
      class="hidden-sm-and-down"
      style="width: 300px"
    >
      <div
        layout="column"
        layout-align="start start"
        class="full-width px2-pc mb10-pc pb-4 mb1-mobile px1-mobile bg-white"
      >
        <div
          layout="row"
          layout-align="start center"
          class="title grey--text text-uppercase font-weight-medium mb-4 mb1-mobile mt3-pc"
        >{{ isCurrent ? $t('representatives.my_last_photos') : $t('representatives.last_photos') }}</div>

        <div
          layout="row"
          layout-align="center center"
          class="full-width"
        >
          <img
            @click="onPhotoClick(p)"
            v-for="(p,i) in photos"
            :key="'lp_'+p.id"
            :src="getImageData(p.id + '-preview') || getImageData(p.id)"
            class="clickable"
            style="max-width: 90px; max-height: 90px;"
            :style="i == 0 ? 'margin-left: 2px' : 'margin-left: 5px'"
          />
          <span
            v-if="!photos || !photos.length"
            class="full-width text-xs-center mt-4 mb-5"
          >{{ isCurrent ? $t('representatives.no_photo_me') : $t('representatives.no_photo') }}</span>
        </div>
      </div>

      <div
        layout="column"
        layout-align="start start"
        class="full-width px2-pc mb10-pc pb-4 mb1-mobile px1-mobile bg-white"
      >
        <div
          layout="row"
          layout-align="start center"
          class="title grey--text text-uppercase font-weight-medium mb-3 mb1-mobile mt3-pc"
        >{{ isCurrent ? $t('representatives.my_last_docs') : $t('representatives.last_docs') }}</div>

        <div
          v-for="d in docs"
          :key="'ld_'+d.id"
          @click="downloadDoc(d)"
          layout="row"
          layout-align="start center"
          class="full-width mb-1 clickable primary--text"
        >
          <v-icon
            color="primary"
            class="ml-0 mr-1"
          >mdi-paperclip</v-icon>
          <span class="break-word">{{d.document.name}}</span>
        </div>

        <div
          v-if="!docs || !docs.length"
          layout="row"
          layout-align="start center"
          class="full-width"
        >
          <span class="full-width text-xs-center mt-4 mb-5">{{ isCurrent ? $t('representatives.no_doc_me') : $t('representatives.no_doc') }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="photoDialog"
      class="photo-dialog active"
      @click="photoDialog = false"
      layout="row"
      layout-align="center center"
    >
      <span
        class="icontainer"
        layout="row"
        layout-align="center center"
      >
        <img :src="getImageData(displayedPhoto + '-1280px') || getImageData(displayedPhoto)" />
      </span>
    </div>
    <representative-form
      :visible.sync="representativeDialog"
      @created="fetchProfile"
      @updated="fetchProfile(); fetch(true)"
      @avatarDeleted="fetchProfile(); fetch(true)"
      :value="editingRepresentative"
    ></representative-form>
    <v-dialog
      v-model="deleteDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title class="title">{{$t('representatives.delete')}}</v-card-title>
        <v-card-text>
          {{$t('representatives.delete_details')}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat="flat"
            @click="deleteDialog = false"
          >
            {{$t('_.cancel')}}
          </v-btn>
          <v-btn
            color="error"
            depressed
            @click="deleteDialog = false; deleteRepresentative()"
          >
            {{$t('_.delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Representatives from "@/api/representatives"
import Messages from "@/api/messages"
import I18nMixin from "@/mixins/i18n"
import Consts from "@/consts"
import ImageMixin from "@/mixins/image"
import Avatar from "@/components/shared/Avatar.vue"
import Message from "@/components/shared/Message.vue"
import Auth from "@/plugins/auth"
import FormDataMixin from "@/mixins/formdata"
import BeatLoader from "vue-spinner/src/BeatLoader.vue"
import axios from "axios"
import moment from "moment"
import DateField from "@/components/shared/DateField"
import RepresentativeForm from "@/components/shared/RepresentativeForm.vue"
import MessageForm from "@/components/shared/MessageForm.vue"

export default {
  mixins: [I18nMixin, ImageMixin, FormDataMixin],
  components: {
    Avatar,
    Message,
    MessageForm,
    BeatLoader,
    DateField,
    RepresentativeForm,
  },
  data () {
    return {
      deleteDialog: false,
      filters: {
        rowsPerPage: 10,
        descending: 1,
        sortBy: "created_at",
        page: 1,
      },
      user: {
        school: {},
      },
      messages: [],
      imgs: {},
      imgsLoad: {},
      isEditingMessage: false,
      isEditingEvent: false,
      startDatepicker: false,
      endDatepicker: false,
      startDatepicker2: false,
      endDatepicker2: false,
      editingMessage: {
        type: Consts.CIRCLE,
        body: "",
        levels_ids: [],
        sectors_ids: [],
        schools_ids: [],
        regional_directorates_ids: [],
        regions_ids: [],
        cities_ids: [],
        date_start: null,
      },
      loading: true,
      noMoreData: false,
      bottom: false,
      photosLoaded: false,
      docsLoaded: false,
      photos: [],
      docs: [],
      editingRepresentative: {
        lang_id: "fr",
        langs_ids: [],
        sector: null,
        birthday: null,
        mandate_start: null,
        mandate_end: null,
      },
      representativeDialog: false,
      displayedPhoto: null,
      photoDialog: false,
    }
  },
  created () {
    this.fetch(true)
    this.fetchProfile()

    window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible()
    })
  },
  watch: {
    bottom (bottom) {
      if (!this.noMoreData && !this.loading && bottom) {
        this.filters.page++
        this.fetch()
      }
    },
    representativeDialog (val) {
      if (!val) {
        this.editingRepresentative = {
          lang_id: "fr",
          langs_ids: [],
          sector: null,
          birthday: null,
          mandate_start: null,
          mandate_end: null,
        }
      }
    },
    "$route.params.id" () {
      if (this.$route.name == "representatives-show") {
        this.photosLoaded = false
        this.docsLoaded = false
        this.fetch(true)
        this.fetchProfile()
      }
    },
  },
  methods: {
    deleteRepresentative () {
      this.loading = true
      Representatives.delete(this.user.id).then(
        () => {
          this.loading = false
          this.$snotify.success(this.$t("representatives.removed"))
          this.$router.push({ name: 'representatives-index' })
        },
        () => {
          this.loading = false
        }
      )
    },
    sendPrivate (user) {
      this.$router.push({
        name: "my-messages",
        params: { newMessage: user },
      })
    },
    onMessageCancel () {
      this.isEditingMessage = false
      this.resetMessage()
    },
    onEventCancel () {
      this.isEditingEvent = false
      this.resetMessage()
    },
    fetch (reset = false) {
      this.loading = true
      if (reset) {
        //On applique un nouveau filtre donc on repart à la 1e page avec de nouveaux messages
        this.messages = []
        this.filters.page = 1
        this.noMoreData = false
      }

      Representatives.getMessages(this.$route.params.id, this.filters).then(
        (res) => {
          this.loading = false

          if (res.data && res.data.length) {
            for (let i = 0; i < res.data.length; i++) {
              this.messages.push(res.data[i])
            }
          } else {
            this.noMoreData = true
          }

          //Les requêtes ne sont effectuées qu'après et seulement si les données ne sont pas déjà chargées
          this.fetchPhotos()
          this.fetchDocs()
          this.$store.commit("LOAD_LOGO")

          if (!this.noMoreData && !this.loading && this.bottomVisible()) {
            this.filters.page++
            this.fetch()
          }
        }
      )
    },
    sendMail () {
      Representatives.sendMail(this.$route.params.id).then(() => {
        this.$snotify.success(this.$t("representatives.mail_sent"))
      })
    },
    fetchProfile () {
      Representatives.get(this.$route.params.id).then((res) => {
        this.user = res.data
        this.imgs = {}
        this.imgsLoad = {}

        if (this.user.avatar_id) {
          this.getImage("/assets/users/" + this.user.id, this.user.id)
        }
      })
    },
    fetchPhotos () {
      if (!this.photosLoaded) {
        Representatives.getPhotos(this.$route.params.id).then((res) => {
          this.photos = res.data

          //Charge les preview des photos ou directement les photos
          for (let i = 0; i < this.photos.length; i++) {
            this.getImage(
              "/assets/messageMediasPreview/" + this.photos[i].id,
              this.photos[i].id + "-preview"
            ).then(
              () => { },
              () => {
                this.getImage(
                  "/assets/messageMedias/" + this.photos[i].id,
                  this.photos[i].id
                )
              }
            )
          }
          this.photosLoaded = true
        })
      }
    },
    fetchDocs () {
      if (!this.docsLoaded) {
        Representatives.getDocs(this.$route.params.id).then((res) => {
          this.docs = res.data
          this.docsLoaded = true
        })
      }
    },
    resetMessage () {
      this.$refs.messageForm.$refs.form.reset()
      this.defaultMessage()
    },
    defaultMessage () {
      this.editingMessage = Object.assign(
        {},
        {
          type: Consts.CIRCLE,
          body: "",
          levels_ids: [],
          sectors_ids: [],
          schools_ids: [],
          regional_directorates_ids: [],
          regions_ids: [],
          cities_ids: [],
          date_start: null,
        }
      )
    },
    onPhotoClick (p) {
      this.getImage(
        "/assets/messageMedias1280px/" + p.id,
        p.id + "-1280px"
      ).then(
        () => { },
        () => {
          this.getImage("/assets/messageMedias/" + p.id, p.id)
        }
      )

      this.displayedPhoto = p.id
      this.photoDialog = true
    },
    newMessage () {
      this.isEditingEvent = false
      this.isEditingMessage = true
      this.defaultMessage()
    },
    newEvent () {
      this.isEditingMessage = false
      this.isEditingEvent = true
      this.defaultMessage()
      this.editingMessage.type = Consts.EVENT
    },
    save (data) {
      if (!this.$refs.messageForm.$refs.form.validate()) {
        return
      }

      if (
        this.isEditingEvent &&
        (!this.editingMessage.date_start ||
          !moment(this.editingMessage.date_start).isValid())
      ) {
        this.$snotify.error(this.$t("messages.date_err"))
        return
      }

      this.loading = true

      // Convert the data to FormData for proper file upload
      let formData = new FormData()
      let o = Object.assign(
        {},
        this.editingMessage,
        { deleted_medias: data.deletedMedias },
        { deleted_docs: data.deletedDocs }
      )
      this._convertObjectToFormData(formData, o)

      if (data.banner && data.banner != {} && data.banner instanceof Blob) {
        formData.append("banner", data.banner, data.banner.name)
      }

      for (let i = 0; i < data.medias.length; i++) {
        if (!data.medias[i].id) {
          formData.append(
            "medias[" + i + "]",
            data.medias[i],
            data.medias[i].name
          )
        }
      }

      for (let i = 0; i < data.documents.length; i++) {
        if (!data.documents[i].id) {
          formData.append(
            "documents[" + i + "]",
            data.documents[i],
            data.documents[i].name
          )
        }
      }

      if (!this.editingMessage.id) {
        Messages.create(formData).then(
          () => {
            this.resetMessage()
            this.loading = false
            this.isEditingMessage = false
            this.isEditingEvent = false
            this.$snotify.success(this.$t("messages.created"))
            this.photosLoaded = false
            this.docsLoaded = false
            this.fetch(true)
          },
          () => {
            this.loading = false
          }
        )
      } else {
        Messages.updateAsForm(this.editingMessage.id, formData).then(
          () => {
            this.resetMessage()
            this.loading = false
            this.isEditingMessage = false
            this.isEditingEvent = false
            this.$snotify.success(this.$t("messages.edited"))
            this.photosLoaded = false
            this.docsLoaded = false
            this.fetch(true)
          },
          () => {
            this.loading = false
          }
        )
      }
    },
    onDelete (i) {
      this.messages.splice(i, 1)
    },
    editMessage (m) {
      if (m.type == Consts.SURVEY) {
        this.$router.push({
          name: "surveys-edit",
          params: { id: m.survey_id },
        })
      } else if (m.type == Consts.EVENT) {
        this.defaultMessage()
        this.editingMessage = JSON.parse(JSON.stringify(m))
        this.isEditingEvent = true
        let a = document.createElement("a")
        document.body.appendChild(a)
        a.style = "display: none"
        a.href = "#message-form"
        a.click()
      } else {
        this.defaultMessage()
        this.editingMessage = JSON.parse(JSON.stringify(m))

        this.isEditingMessage = true
        let a = document.createElement("a")
        document.body.appendChild(a)
        a.style = "display: none"
        a.href = "#message-form"
        a.click()

        this.editingMessage.levels_ids = []
        this.editingMessage.sectors_ids = []
        this.editingMessage.regional_directorates_ids = []
        this.editingMessage.regions_ids = []
        this.editingMessage.cities_ids = []
        this.editingMessage.schools_ids = []

        for (
          let i = 0;
          i < this.editingMessage.regional_directorates.length;
          i++
        ) {
          this.editingMessage.regional_directorates_ids.push(
            this.editingMessage.regional_directorates[i].id
          )
        }

        for (let i = 0; i < this.editingMessage.regions.length; i++) {
          this.editingMessage.regions_ids.push(
            this.editingMessage.regions[i].id
          )
        }

        for (let i = 0; i < this.editingMessage.schools.length; i++) {
          this.editingMessage.schools_ids.push(
            this.editingMessage.schools[i].id
          )
        }

        for (let i = 0; i < this.editingMessage.levels.length; i++) {
          this.editingMessage.levels_ids.push(
            this.editingMessage.levels[i].level
          )
        }

        for (let i = 0; i < this.editingMessage.sectors.length; i++) {
          this.editingMessage.sectors_ids.push(
            this.editingMessage.sectors[i].sector
          )
        }

        for (let i = 0; i < this.editingMessage.cities.length; i++) {
          this.editingMessage.cities_ids.push(this.editingMessage.cities[i].id)
        }
      }
    },
    itemName (item) {
      return this.i18n(item.name)
    },
    itemLabel (item) {
      return this.i18n(item.label)
    },
    parseDate (date) {
      if (!date) return null

      if (date.indexOf("-") >= 0) {
        return date
      }

      return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD")
    },
    bottomVisible () {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight
      return bottomOfPage || pageHeight < visible
    },
    downloadDoc (doc) {
      const doc_id = doc.id
      axios
        .get(`/assets/messageDocs/${doc_id}`, { responseType: "blob" })
        .then((res) => {
          this.downloadFile(res.data, doc.document.name)
        })
    },
    levelLabel (l) {
      switch (l) {
        case Consts.MINISTRY:
          return this.$t("users.lv_min")
        case Consts.NATIONAL:
          return this.$t("users.lv_nat")
        case Consts.SECTORAL:
          return this.$t("users.lv_sec")
        case Consts.LOCAL:
          return this.$t("users.lv_loc")
      }
    },
    levelColor (l) {
      switch (l) {
        case Consts.MINISTRY:
          return "primary"
        case Consts.NATIONAL:
          return "pink"
        case Consts.SECTORAL:
          return "secondary"
        case Consts.LOCAL:
          return "brown"
      }
    },
    editProfile () {
      this.editingRepresentative = JSON.parse(
        JSON.stringify(Object.assign({}, this.user))
      )
      /*if(this.editingRepresentative.langs_ids === undefined){
          this.editingRepresentative.langs_ids = [];

          for(let i = 0; i < this.editingRepresentative.langs.length; i++){
              this.editingRepresentative.langs_ids.push(this.editingRepresentative.langs[i].id);
          }
      }*/
      this.representativeDialog = true
    },
  },
  computed: {
    sectors () {
      return [
        { value: Consts.PRIMARY, text: this.$t("schools.sector_prim") },
        { value: Consts.SECONDARY, text: this.$t("schools.sector_sec") },
        {
          value: Consts.COMPETENCECENTRE,
          text: this.$t("schools.sector_comp"),
        },
      ]
    },
    primary () {
      return Consts.PRIMARY
    },
    secondary () {
      return Consts.SECONDARY
    },
    levels () {
      return [
        { value: Consts.MINISTRY, text: this.$t("users.lv_min") },
        { value: Consts.NATIONAL, text: this.$t("users.lv_nat") },
        { value: Consts.SECTORAL, text: this.$t("users.lv_sec") },
        { value: Consts.LOCAL, text: this.$t("users.lv_loc") },
      ]
    },
    types () {
      return [
        {
          value: Consts.EVENT,
          text: this.$t("messages.evts"),
          icon: "calendar",
        },
        {
          value: Consts.SURVEY,
          text: this.$t("messages.surveys"),
          icon: "clipboard-text",
        },
        {
          value: Consts.CIRCLE,
          text: this.$t("messages.int_msgs"),
          icon: "set-none",
        },
        {
          value: Consts.PLATFORM,
          text: this.$t("messages.public_msgs"),
          icon: "send",
        },
        {
          value: Consts.TOPDOWN,
          text: this.$t("messages.topdowns"),
          icon: "arrow-expand-down",
        },
        {
          value: Consts.BOTTOMUP,
          text: this.$t("messages.bottomups"),
          icon: "arrow-expand-up",
        },
        {
          value: Consts.HORIZONTAL,
          text: this.$t("messages.horizontal"),
          icon: "arrow-expand-horizontal",
        },
      ]
    },
    isMinistry () {
      if (Auth.user.level == Consts.MINISTRY || Auth.user.is_admin) {
        return true
      }
      return false
    },
    isCurrent () {
      if (this.user && this.user.id == Auth.user.id) {
        return true
      }
      return false
    },
    isNational () {
      if (Auth.user.level == Consts.NATIONAL) {
        return true
      }
      return false
    },
    isSectoral () {
      if (Auth.user.level == Consts.SECTORAL) {
        return true
      }
      return false
    },
    isLocal () {
      if (Auth.user.level == Consts.LOCAL) {
        return true
      }
      return false
    },
  },
};
</script>
<style>
.exp-header > .v-expansion-panel__header > div {
  margin-left: 5px;
  font-weight: bold;
}
.exp-header
  > .v-expansion-panel__header
  > .v-expansion-panel__header__icon
  > .v-icon {
  position: absolute;
  left: 0;
  margin-left: 0px;
  margin-right: 5px;
  top: 12px;
  font-weight: bold;
}
.exp-ctn {
  box-shadow: none;
}
.photo-dialog {
  position: relative;
  cursor: pointer;
  margin: 12px;
}
.photo-dialog.active {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.75);
  margin: 0;
  z-index: 5;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.photo-dialog > .icontainer {
  text-align: center;
}
.photo-dialog.active > .icontainer {
  width: 100%;
  height: 100%;
}
.photo-dialog.active img {
  max-width: 100%;
  max-height: 100%;
  z-index: 8;
  margin: auto;
}
.photo-dialog > div {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  padding: 8px;
  color: white;
  background-color: rgba(0, 0, 0, 0.75);
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}
.photo-dialog > div > div {
  pointer-events: none;
}
.photo-dialog:hover > div {
  opacity: 1;
}
.photo-dialog.active > div {
  opacity: 1;
  top: 0;
  bottom: unset;
}
</style>
<style scoped>
@media screen and (min-width: 960px) {
  .messages-col {
    margin-right: 40px;
    margin-left: 30px;
  }
}
.active-form {
  font-weight: bold;
  color: #2e3b7f;
}
</style>